import { CouponMessageCard } from "@swiggy-private/cart-types";
import { isEmpty, replaceAllOccurence } from "@swiggy-private/core-ui";

export const getAriaLabel = (textToShowInMiddle: string, data: CouponMessageCard): string => {
    let ariaLabel = "";
    if (textToShowInMiddle || data.title) ariaLabel = data.title;
    if (textToShowInMiddle) ariaLabel = ariaLabel.concat(", ", textToShowInMiddle);
    if (!isEmpty(textToShowInMiddle) && !isEmpty(data.secondaryDiscountCallout))
        ariaLabel = ariaLabel.concat(", ", data.secondaryDiscountCallout);
    if (!isEmpty(data.description)) ariaLabel = ariaLabel.concat(". ", data.description);

    return replaceAllOccurence(ariaLabel, "₹", "rupees ");
};

export const getMoreOffersStripData = (data: CouponMessageCard): Record<string, unknown> => {
    return {
        headerString: data.card_footer?.text,
        subHeadString: data.card_footer?.subtext,
    };
};
